const RELOAD_KEY = 'lvm:event-chunk-reload-at';
const RELOAD_WINDOW_MS = 15 * 60 * 1000;

// A cached app can reference a chunk removed by a deployment. Retrying that
// same URL cannot recover it; one fresh document supplies the current URLs.
export const recoverEventChunk = (error, { hasCart = false, browser = window, now = Date.now() } = {}) => {
  const chunkFailed = error?.name === 'ChunkLoadError'
    || error?.code === 'CSS_CHUNK_LOAD_FAILED'
    || /Loading (?:CSS )?chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(error?.message || '');
  if (!chunkFailed || hasCart) return false;

  try {
    const { pathname, search } = browser.location;
    // Only an event's initial entry is safe to refresh. Never refresh checkout,
    // forms, or an embed handoff with a preselected basket.
    const params = new URLSearchParams(search);
    if (!/^\/events\/[^/]+\/?$/.test(pathname) || params.has('embed') || params.has('tickets')) return false;
    const previous = Number(browser.sessionStorage.getItem(RELOAD_KEY));
    if (previous > 0 && now - previous < RELOAD_WINDOW_MS) return false;
    browser.sessionStorage.setItem(RELOAD_KEY, String(now));
    browser.location.reload();
    return true;
  } catch (_error) {
    // Without a durable session marker we cannot rule out a reload loop.
    return false;
  }
};
